import { useMemo } from 'react';

import { DOCUMENTATION_TYPES } from '../../constants';

const useInsuranceCards = ({
  frontSide,
  backSide,
  frontSideKey,
  backSideKey,
}) => {
  return useMemo(() => {
    return [
      {
        key: frontSideKey || DOCUMENTATION_TYPES.CARD_1,
        attachment: frontSide,
      },
      {
        key: backSideKey || DOCUMENTATION_TYPES.CARD_2,
        attachment: backSide,
      },
    ];
  }, [frontSide, backSide, frontSideKey, backSideKey]);
};

export default useInsuranceCards;



// WEBPACK FOOTER //
// ./src/hooks/patientInsurance/useInsuranceCards.js